/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Ikhgesellschaft15Inputs */

const en__field_enum_ikhgesellschaft15 = /** @type {(inputs: _Field_Enum_Ikhgesellschaft15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`03 - Gesellschaftswissenschaften`)
};

const de__field_enum_ikhgesellschaft15 = /** @type {(inputs: _Field_Enum_Ikhgesellschaft15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`03 - Gesellschaftswissenschaften`)
};

/**
* | output |
* | --- |
* | "03 - Gesellschaftswissenschaften" |
*
* @param {_Field_Enum_Ikhgesellschaft15Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_ikhgesellschaft15 = /** @type {((inputs?: _Field_Enum_Ikhgesellschaft15Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Ikhgesellschaft15Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_ikhgesellschaft15(inputs)
	return de__field_enum_ikhgesellschaft15(inputs)
});
export { _field_enum_ikhgesellschaft15 as "_field_enum_IKHGESELLSCHAFT" }